module.exports = ".contribuente-box{\r\n\tpadding: 5px 15px;\r\n\tmin-height: 100%;\r\n\tmax-height: 100%;\r\n\twidth: 100%;\r\n}\r\n"